/**
 * @generated SignedSource<<b4a83a6f408cfe81b2c9fe333428c473>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SingleTreeStateScreenScreen_Query$variables = {
  id: string;
};
export type SingleTreeStateScreenScreen_Query$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"SingleTreeStateScreen_TreeStateFragment">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ContentSubmissionsTable_QueryFragment">;
};
export type SingleTreeStateScreenScreen_Query = {
  response: SingleTreeStateScreenScreen_Query$data;
  variables: SingleTreeStateScreenScreen_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "Variable",
  "name": "treeStateId",
  "variableName": "id"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "structureDefinition",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "storageKey": null
  },
  (v4/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SingleTreeStateScreenScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SingleTreeStateScreen_TreeStateFragment"
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ContentSubmissionsTable_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SingleTreeStateScreenScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "progressPercentage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TreeNode",
                "kind": "LinkedField",
                "name": "rootNode",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "definition",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "userExtensionKind",
                        "value": "InfectopharmUserExtension"
                      }
                    ],
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "extension",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "salutation",
                            "storageKey": null
                          }
                        ],
                        "type": "InfectopharmUserExtension",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TreeState",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnV2AdminSchema",
            "kind": "LinkedField",
            "name": "LearnV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100
                  },
                  (v2/*: any*/)
                ],
                "concreteType": "ContentSubmissionsConnection",
                "kind": "LinkedField",
                "name": "GetContentSubmissions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentSubmissionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentSubmission",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastUpdated",
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "rewardResults",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "kind",
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "pointsPoolName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "amount",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PointsRewardWasPossibleResult",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "certificateName",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "CertificateRewardWasPossibleResult",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "recipientType",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "EmailRewardWasPossibleResult",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "PassedELearningContentSubmissionDefinition",
                                "abstractKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LearnOpportunityV2",
                            "kind": "LinkedField",
                            "name": "learnOpportunity",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LearnOpportunityV2",
                                "kind": "LinkedField",
                                "name": "root",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8da8512e05f228feb36b2464a6aba83d",
    "id": null,
    "metadata": {},
    "name": "SingleTreeStateScreenScreen_Query",
    "operationKind": "query",
    "text": "query SingleTreeStateScreenScreen_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...SingleTreeStateScreen_TreeStateFragment\n    id\n  }\n  ...ContentSubmissionsTable_QueryFragment_1DEasS\n}\n\nfragment ContentSubmissionsTable_ContentSubmissionFragment on ContentSubmission {\n  ...LastUpdatedAtColumn_ContentSubmissionFragment\n  ...StartedAtColumn_ContentSubmissionFragment\n  ...ProjectRewardsColumn_ContentSubmissionFragment\n  ...RootNodeTitleColumn_ContentSubmissionFragment\n  ...StatusColumn_ContentSubmissionFragment\n}\n\nfragment ContentSubmissionsTable_QueryFragment_1DEasS on Query {\n  Admin {\n    LearnV2 {\n      GetContentSubmissions(first: 100, treeStateId: $id) {\n        edges {\n          node {\n            ...ContentSubmissionsTable_ContentSubmissionFragment\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment LastUpdatedAtColumn_ContentSubmissionFragment on ContentSubmission {\n  lastUpdated\n}\n\nfragment ProjectRewardsColumn_ContentSubmissionFragment on ContentSubmission {\n  definition {\n    __typename\n    ... on PassedELearningContentSubmissionDefinition {\n      rewardResults {\n        __typename\n        kind\n        ... on PointsRewardWasPossibleResult {\n          pointsPoolName\n          amount\n        }\n        ... on CertificateRewardWasPossibleResult {\n          certificateName\n        }\n        ... on EmailRewardWasPossibleResult {\n          recipientType\n        }\n      }\n    }\n  }\n}\n\nfragment ProjectUserDescription_UserFragment on User {\n  ...UserDescription_UserFragment\n}\n\nfragment RootNodeTitleColumn_ContentSubmissionFragment on ContentSubmission {\n  learnOpportunity {\n    root {\n      structureDefinition {\n        __typename\n        title\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment SingleTreeStateScreen_TreeStateFragment on TreeState {\n  id\n  progressPercentage\n  rootNode {\n    structureDefinition {\n      __typename\n      title\n    }\n    id\n  }\n  startedAt\n  definition {\n    __typename\n    status\n  }\n  user {\n    id\n    ...ProjectUserDescription_UserFragment\n  }\n}\n\nfragment StartedAtColumn_ContentSubmissionFragment on ContentSubmission {\n  startedAt\n}\n\nfragment StatusColumn_ContentSubmissionFragment on ContentSubmission {\n  definition {\n    __typename\n    status\n  }\n}\n\nfragment UserDescription_UserFragment on User {\n  extension(userExtensionKind: InfectopharmUserExtension) {\n    __typename\n    ... on InfectopharmUserExtension {\n      firstName\n      lastName\n      title\n      salutation\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "477faa83fe94f307b56f5c37e24bbdf2";

export default node;
